import {RailsApi} from './rails.api.js'

/**
 * Dynamic Cohort Enrollments API
 */
export class DynamicCohortEnrollmentsApi extends RailsApi {

  basePath = 'dynamic_cohort_enrollments'
  convertJsonKeys = true

  /**
   * Kick off the cohort enrollment job
   */
  async kickOff() {
    const json = await this.post('/')
    return json?.status
  }

  /**
   * Check the status of the enrollment job
   * No key needed - backend derives user from cookie token.
   */
  async checkStatus() {
    const json = await this.get('/')
    return json?.status
  }
}

//Export singleton instance
export const dynamicCohortEnrollmentsApi = new DynamicCohortEnrollmentsApi()
